import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {useCallback, useState} from "react";
import {OtsAsyncThunkConfigExtra, OtsState} from "../store/ots-store";
import {removeUndefined} from "../util/util";
import {SearchCriteria} from "../model/report/report";
import {buildStandardHeaders} from "../store/ots-api";

export type UseDownloadCompanyTransportServicesReportProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadCompanyTransportServicesReportResult = {
  download: (criteria: SearchCriteria) => void
  report?: string
  error?: any
  loading: boolean
}

export const useDownloadCompanyTransportServicesReport = (props: UseDownloadCompanyTransportServicesReportProps): UseDownloadCompanyTransportServicesReportResult => {
  const {baseQueryApi} = props

  const [_report, _setReport] = useState<string | undefined>(undefined)
  const [_error, _setError] = useState()
  const [_loading, _setLoading] = useState<boolean>(false)

  const _download = useCallback((criteria: SearchCriteria) => {

    _setReport(undefined)
    _setLoading(true)
    _setError(undefined)

    const headers = buildStandardHeaders(baseQueryApi)
    headers["Accept"] = 'application/json'
    headers["Content-Type"] = 'application/json'

    const request: RequestInit = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(criteria),
    }

    const baseUrl = (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl;
    const url = `${baseUrl}/reports/restricted/company-transport-services`;

    window.fetch(url, request)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorDetail) => {
            return Promise.reject(errorDetail);
          });
        }
        return response.text();
      })
      .then((text) => {
        _setReport(text);
        _setError(undefined);
      })
      .catch((error) => {
        _setError(error);
        _setReport(undefined);
      })
      .finally(() => {
        _setLoading(false);
      });
  }, [baseQueryApi])

  return {
    download: _download,
    report: _report,
    error: _error,
    loading: _loading,
  }
}
